<template>
    <div>
        <page-header :btnNew="this.$hasPermission('Lot_create', true) ? 'ACTIONS.NEW' : ''" pageTitle="LOTS.INDEX_TITLE"
                     @newType="setRegisterModal"/>
        <div class="card paddin mb-1">
            <div class="row gutters">
                <div :class="this.$hasPermission('Lot_create', true) ? 'col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10':
               'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <div class="tags-block mt-1 ml-2 row left-content" v-if="subtitles">
                        <div class="tags" v-for="sub in subtitles" :key="sub.id">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color': sub?.backgroud_collor}"></i> {{ sub.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2" v-if="this.$hasPermission('Lot_create', true)">
                    <div class="text-right mr-3">
                        <div data-cy="lot_index_dropdown" class="pointer" style="font-size: 20px"
                                id="import-buttom"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="icon-menu"/>
                        </div>
                        <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-lot" id="dropdown-import">
                            <div data-cy="lot_index_button_import" class="dropdown-item bg-hover-black"
                                 @click="uploadFile = true">
                                <div class="row item-custom2 ml-1 text-white ">
                                    <i class="icon-folder_open mr-2 font-15"/>{{ t('GENERAL.MSG.IMPORT_FILE') }} XLSX
                                </div>
                            </div>
                            <div class="dropdown-item bg-hover-black">
                                <a class="row item-custom2 ml-1 text-white" @click="exportLot">
                                    <i class="icon-file mr-2 font-15"/>{{ t('PROPERTIES.EXPORT_FILE_LOT') }} XLSX
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black">
                                <a class="row item-custom2 ml-1 text-white" href="Modelo para Importação Lote.xlsx"
                                   download>
                                    <i class="icon-arrow-with-circle-down mr-2 font-15"/>{{
                                        t('GENERAL.MSG.DOWNLOAD_FILE_EXEMPLE')
                                    }}
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black" v-if="this.$hasPermission('Readjustment_property', true)">
                                <a class="row item-custom2 ml-1 text-white" data-target="#customModalTwo"
                                   data-toggle="modal"
                                   @click="setModalReadjustment">
                                    <i class="icon-local_atm mr-2 font-15"/>{{ t('LOTS.APPLY_VALUE_READJUSTMENT') }}
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black" v-if="this.$hasPermission('Readjustment_property', true)">
                                <a class="row item-custom2 ml-1 text-white" data-target="#customModalTwo"
                                   data-toggle="modal"
                                   @click="setModalBlockLiberty">
                                    <i class="icon-pencil mr-2 font-15"/>{{ t('LOTS.ALTER_STATUS_LOTS') }}
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black" v-if="this.$hasPermission('Readjustment_property', true)">
                                <a class="row item-custom2 ml-1 text-white" data-target="#customModalTwo"
                                   data-toggle="modal"
                                   @click="setModalAlterStep">
                                    <i class="icon-layers mr-2 font-15"/>{{ t('LOTS.ALTER_STEP_LOTS') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card filter-panel-card mb-1">
            <div class="filter-panel-header">
                <div class="filter-panel-title">
                    <i class="icon-search1"></i>
                    <span>Filtros</span>
                </div>
            </div>
            <div class="row filter-panel-row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="filter-panel-field filter-panel-field-allotment">
                        <label for="state" class="filter-panel-label">
                            {{ t('NAV.ALLOTMENT') }}
                        </label>
                        <Select2 :settings="{ width:'100%', placeholder: 'Selecione um Loteamento' }"
                                 id="allotment"
                                 :disabled="!hastwoAllotments"
                                 name="allotment" v-model="allotment_id"
                                 :options="allotments" @select="changeAllotment($event, true)"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" >
                    <div class="filter-panel-field filter-panel-field-step">
                        <label for="state" class="filter-panel-label">
                            Etapas
                        </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione uma Etapa' }"
                                 id="step"
                                 :disabled="steps?.length <= 1"
                                 name="step" v-model="step_id"
                                 :options="[{id:'selecione', text:'Selecione'}, ...steps]"
                                 @select="changeStep($event)"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="filter-panel-field filter-panel-field-status">
                        <label for="status_lot" class="filter-panel-label">
                            Situação
                        </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione' }"
                                 id="status_lot"
                                 name="status_lot" v-model="status_id"
                                 :options="[{id:'selecione', text:'Selecione'}, ...subtitles]"
                                 @select="changeStep($event, 'subtitle')"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="filter-panel-field filter-panel-field-owner">
                        <label for="owner_filter" class="filter-panel-label">
                            Proprietários
                        </label>
                        <Select2 :settings="settingsOwner"
                                 id="owner_filter"
                                 :placeholder="owner_name ? owner_name : ''"
                                 name="owner_filter" v-model="owner_id"
                                 @select="changeStep($event, 'owners')"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(block, key) in blocks" :key="block">
            <div class="accordion toggle-icons" id="toggleIcons" v-if="hasBlocks">
                <div class="accordion-container">
                    <div class="accordion-header" :id="'toggleIcons' + block.title">
                        <a data-toggle="collapse" :data-target="'#toggleIconsCollapse' + block.title"
                           :aria-expanded="key == 0 ? true: false"
                           :aria-controls="'toggleIconsCollapse' + block.title"
                           @click="indexLotsByAllotment(allotment_id, block.text)"
                           class="lot-block-header-link">
                            <span class="lot-block-header-title">
                                <i class="icon-grid"></i>
                                {{ t('PROPERTIES.BLOCK') }} {{ block.text }}
                                <span class="lot-block-header-count" v-if="lots[block.text]">
                                    {{ lots[block.text].length }} {{ t('LOTS.LOT') }}{{ lots[block.text].length === 1 ? '' : 's' }}
                                </span>
                            </span>
                        </a>
                    </div>
                    <div :id="'toggleIconsCollapse' + block.title" class="collapse"
                         :class="{show: block.text == blockOpen}"
                         :aria-labelledby="'toggleIcons' + block.title" :data-parent="'#toggleIcons' + block.title">
                        <div class="accordion-body">
                            <div class="text-center"
                                 v-if="isLoadingLots && (isLoadingLots.block == block.text && isLoadingLots.isLoading)">
                                <div class="spinner-border m" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="row gutters">
                                <div v-for="lot in lots[block.text]" :key="lot.id"
                                     class="col-xl-1 col-lg-4 col-md-6 col-sm-6 col-6 text-center">
                                    <div class="card dynamic-background-card" :id="lot.id"
                                          :style="{'--dynamic-bg': getBackgroundCollor(lot)}"
                                          v-if="this.$hasPermission('Lot_show', true)">
                                        <a data-cy="lot_index_modal" href="#" data-target="#modalShow"
                                           data-toggle="modal"
                                           @click="setShowModal(lot)">
                                            <h3 class="mt-1 dynamic-text-color" :style="{'--dynamic-color': getTextCollor(lot.properties_status_id)}">{{
                                                     lot.name
                                                 }}</h3>
                                            <p class="hide-text dynamic-text-color" :style="{'--dynamic-color': getTextCollor(lot.properties_status_id)}">
                                                 {{ lot.properties_type_name }}</p>
                                            <p class="dynamic-text-color" :style="{'--dynamic-color': getTextCollor(lot.properties_status_id)}">{{ lot.total_area }} m²</p>
                                            <p class="font-weight-bold dynamic-text-color" :style="{'--dynamic-color': getTextCollor(lot.properties_status_id)}">
                                                 {{ toCurrency(lot.price) }}</p>
                                        </a>
                                    </div>
                                    <div class="card dynamic-background-card" :id="lot.id"
                                          :style="{'--dynamic-bg': getBackgroundCollor(lot)}"
                                          v-if="!this.$hasPermission('Lot_show', true)">
                                        <h3 class="mt-1 dynamic-text-color" :style="{'--dynamic-color': lot?.status?.text_collor}">{{ lot.name }}</h3>
                                        <p class="dynamic-text-color" :style="{'--dynamic-color': lot?.status?.text_collor}">{{ lot.total_area }} m²</p>
                                        <p class="font-weight-bold dynamic-text-color" :style="{'--dynamic-color': lot?.status?.text_collor}">
                                             {{ toCurrency(lot.price) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="!hasBlocks || !allotments">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('LOTS.INDEX_TITLE'), os: 'os'}) }}</h5>
                </div>
            </div>
        </div>

        <modal
               modalXXl
               :titleModal="modalTitle"
               @close="closeModal">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <create-lot v-if="whichModal === 1 && (hastwoAllotments && allotments || !hastwoAllotments && allotment_id)"
                        :hastwoAllotments="hastwoAllotments" :isEdit="isEdit"
                        :properties-status-index="propertiesStatus"
                        :steps="steps"
                        :propertiesIndex="properties" :lotsIndex="lotsIndex"
                        :allotments="hastwoAllotments ? allotments : allotment_id"
                        @created="afterCreate($event)"
                        :allotmentSelected="allotmentSelect"
                        @edited="afterEdit($event)">
            </create-lot>

            <create-reserve v-if="whichModal === 2 && reserve && (reserveTypesIndex && reserveTypesIndex[0])"
                            :reserveIndex="reserve" idModal="modalReserve"
                            :allotmentsIndex="allotments" :blocksIndex="blocks"
                            :isRealtor="!this.$hasPermission('Reserve_confirm', true)"
                            :reserveTypesIndex="reserveTypesIndex" @created="updateAfterCreated($event)">
            </create-reserve>

            <view-lot v-if="whichModal === 3 && properties.id && lotsIndex" :propertiesIndex="properties"
                      :properties-status-index="propertiesStatus" :steps="steps"
                      :lotsIndex="lotsIndex" :hastwoAllotments="hastwoAllotments" :allotmentSelected="allotmentSelect">
            </view-lot>
            <iframe :src="srcIframe" :allow="`clipboard-read ${hostSimulator}; clipboard-write ${hostSimulator}`"
                    sandbox="allow-downloads allow-scripts allow-forms allow-same-origin allow-clipboard-read allow-clipboard-write"
                    style="height: 80vh!important;" v-if="whichModal === 4 && srcIframe"/>
            <div class="modal-footer right-content" v-if="whichModal === 4">
                <button data-cy="lot_index_simulate_close" class="btn btn-secondary" data-dismiss="modal" type="button">
                    {{ t('ACTIONS.CLOSE') }}
                </button>
            </div>

            <readjustment-lot-component v-if="whichModal === 5" :allotmentIndex="allotments"
                                        :allotmentIdIndex="allotment_id"
                                        :properties-type="propertiesType"
                                        :properties-status="propertiesStatus"
                                        @Readjusted="indexAllotment">
            </readjustment-lot-component>
            <alter-status-lot-in-mass-component v-if="whichModal === 6" :allotmentIndex="allotments"
                                                 :status-to="status_to" :status-from="status_from"
                                                 :allotmentIdIndex="allotment_id" :properties-status="propertiesStatus"
                                                 :properties-type="propertiesType"
                                                 @updated="indexAllotment"></alter-status-lot-in-mass-component>
            <alter-status-lot-in-mass-component v-if="whichModal === 7" :allotmentIndex="allotments"
                                                 mode="step"
                                                 :status-to="status_to" :status-from="status_from"
                                                 :allotmentIdIndex="allotment_id" :properties-status="propertiesStatus"
                                                 :properties-type="propertiesType"
                                                 @updated="indexAllotment"></alter-status-lot-in-mass-component>
        </modal>

        <show-lot v-if="modalTitle === 'LOTS.LOT_INFORMATION'"
                  :lotsIndex="lotsIndex"
                  :modalTitle="modalTitle"
                  @update="setEditModal($event)"
                  @view="setViewModal($event)"
                  @delete="setDelete($event)"
                  @reserve="setRegisterModalReserve($event)"
                  @simulate="setSimulateModal">
        </show-lot>
        <upload-modal :uploadFile="uploadFile" @upload="uploadFile = $event"
                      @import="importFile($event)"></upload-modal>
        <modal-select-allotment v-if="allotments" :showModal="showAllotmentSelect"
                                scope-allotment
                                @showModal="showAllotmentSelect = $event"
                                @allotmentSelected="allotmentSelected"
        ></modal-select-allotment>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import Lots from '@/services/Lots';
import Modal from '@/components/modal';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import viewLot from './viewLotComponent.vue';
import showLot from './showLotComponent.vue';
import Properties from '@/services/Properties';
import Validate from '@/components/validate.vue';
import createLot from './createLotComponent.vue';
import ReserveTypes from '@/services/ReserveTypes';
import Allotments from '../../services/Allotments';
import UserCompanies from '../../services/UserCompanies';
import pageHeader from '@/components/layouts/pageHeader';
import propertyTypes from '../../services/propertyTypes';
import uploadModal from '@/components/layouts/uploadModal';
import BuildSimulatorUrl from '@/Helpers/BuildSimulatorUrl';
import createReserve from '../reserve/createReserveComponent';
import readjustmentLotComponent from './readjustmentLotComponent';
import modalSelectAllotment from '../allotment/modalSelectAllotmentComponent.vue';
import alterStatusLotInMassComponent from './alterStatusLotInMassComponent';
import widthMd from '../../mixins/widthMd';
import Steps from '../../services/Steps';

export default {
    name: 'indexLot',
    mixins: [Validate, BuildSimulatorUrl, widthMd],
    components: {
        Modal,
        Select2,
        viewLot,
        showLot,
        createLot,
        pageHeader,
        uploadModal,
        createReserve,
        modalSelectAllotment,
        readjustmentLotComponent,
        alterStatusLotInMassComponent,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    computed: {
        ...mapState({
            allotments: 'allotments',
            lotModified: 'lotModified',
            allotmentLoad: 'allotmentLoad',
            loopLots: 'loopLots',
            hastwoAllotments: 'hastwoAllotments',
        }),
        hostSimulator() {
            return process.env.VUE_APP_SIMULATOR_HOST;
        }
    },
    beforeRouteLeave() {
        sessionStorage.removeItem('stepId');
        sessionStorage.removeItem('statusId');
    },
    data() {
        return {
            id: null,
            step_id: sessionStorage.getItem('stepId'),
            status_id: sessionStorage.getItem('statusId'),
            owner_id: sessionStorage.getItem('ownerId'),
            owner_name: sessionStorage.getItem('ownerName'),
            lots: [],
            steps: [],
            name: null,
            blocks: null,
            isEdit: null,
            reserve: null,
            lotsIndex: {},
            modalTitle: '',
            properties: {},
            srcIframe: null,
            blockOpen: null,
            allotment: null,
            subtitles: [],
            hasBlocks: false,
            whichModal: null,
            uploadFile: false,
            allotment_id: null,
            propertiesType: [],
            allotmentSelect: {},
            isLoadingLots: null,
            propertiesStatus: [],
            status_from: [],
            status_to: [],
            reserveTypesIndex: null,
            showAllotmentSelect: false,
            settingsOwner: {
                width: '100%',
                placeholder: sessionStorage.getItem('ownerName') ? sessionStorage.getItem('ownerName') : 'Selecione',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/proprietarios`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                        'allotment-id': sessionStorage.getItem('allotmentIdScope'),
                    },
                    data: params => {
                        return {
                            name: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id:'selecione', text:'Selecione'});
                            return {
                                results: data.map(({id, text: text}) => ({id, text}))
                            };
                        } else {
                            return {results: ""};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
        };
    },
    unmounted() {
        clearInterval(this.loopLots);
    },
    beforeUnmount() {
        clearInterval(this.loopLots);
    },
    async mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        await this.indexSituation();
        await this.loadIndexLotes();
        await this.listPropertyesType();
        await this.listPropertiesStatus();
    },
    watch: {
        lotModified: function () {
            if (this.lotModified[0]) {
                this.lotModified.forEach(lot => {
                    this.lots[lot.block]?.forEach((l, key) => {
                        if (l.name == lot.name) {
                            this.lots[lot.block][key] = lot;
                        }
                    });
                });
            }
        },
        allotments: function () {
            if (!sessionStorage.getItem('allotmentIdScope')) {
                this.loadIndexLotes();
            }
        },
    },
    methods: {
        getStatusById(id) {
            return this.propertiesStatus.find(status => status.id === id)
                ?? this.subtitles.find(status => status.id === id);
        },
        getTextCollor(id) {
            if (id){
                let i = this.getStatusById(id);
                return i?.text_collor ? i.text_collor : '#000000';
            }
            return '#000000';
        },
        getBackgroundCollor(lot) {
            let id = lot.properties_status_id ? lot.properties_status_id : lot?.status?.id;
            if (id){
                let i = this.getStatusById(id);
                return i?.backgroud_collor ? i.backgroud_collor : '#FFFFFF';
            }
            return '#FFFFFF';
        },
        async loadIndexLotes() {
            if (sessionStorage.getItem('allotmentIdScope')) {
                await this.chanceCustomScope(sessionStorage.getItem('allotmentIdScope'));
                if (sessionStorage.getItem('allotmentIdScope')) {
                    this.listSteps();
                    this.indexAllotment();
                }
            } else if (this.allotments?.length === 1) {
                let allotmentId = this.allotments.find(i => i).id;
                await this.chanceCustomScope(allotmentId);
                sessionStorage.setItem('allotmentIdScope', allotmentId);
                this.settingsOwner.ajax.headers['allotment-id'] = allotmentId;
                if (sessionStorage.getItem('allotmentIdScope')) {
                    this.listSteps()
                    this.indexAllotment();
                }
            } else if (this.allotments?.length) {
                this.showAllotmentSelect = true;
            }
        },
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        changeStep({id, text}, action = null) {
            if (action === 'subtitle'){
                if (id === 'selecione') {
                    sessionStorage.removeItem('statusId');
                    this.status_id = null;
                } else {
                    sessionStorage.setItem('statusId', id);
                    this.status_id = id;
                }
            }else if (action === 'owners') {
                if (id === 'selecione') {
                    sessionStorage.removeItem('ownerId');
                    sessionStorage.removeItem('ownerName');
                    this.owner_id = null;
                    this.owner_name = null;
                } else {
                    sessionStorage.setItem('ownerId', id);
                    sessionStorage.setItem('ownerName', text);
                    this.owner_id = id;
                    this.owner_name = text;
                }
            }else{
                if (id === 'selecione') {
                    sessionStorage.removeItem('stepId');
                    this.step_id = null;
                } else {
                    sessionStorage.setItem('stepId', id);
                    this.step_id = id;
                }
            }
            this.changeAllotment({id: this.allotment_id})
        },
        handleBeforeUnload() {
            clearInterval(this.loopLots);
        },
        async listPropertyesType() {
            await propertyTypes.list().then(resp => this.propertiesType = resp.data);
        },
        listSteps() {
            Steps.listForAllotment(sessionStorage.getItem('allotmentIdScope')).then((resp) => {
                this.steps = resp.data;
                if (this.steps.length === 1){
                    this.step_id = this.steps[0].id;
                }
            }).catch(() => {
                this.steps = [];
            })
        },
        closeModal() {
            this.whichModal = null;
            this.isEdit = false;
            this.properties = {};
            this.lotsIndex = {};
            this.modalTitle = '';
        },
        async listPropertiesStatus() {
            await Properties.listStatusComplet().then(resp => {
                this.propertiesStatus = resp.data;
                this.propertiesStatus.forEach(i => i.text = i.name);
            });
        },
        async indexAllotment(updateBlock = false) {
            clearInterval(this.loopLots);
            if (sessionStorage.getItem('allotmentIdScope')) {
                this.allotment_id = sessionStorage.getItem('allotmentIdScope');
                this.allotmentSelect = this.allotments?.find(item => item.id === this.allotment_id);
                this.startLot(this.allotment_id, updateBlock);
            }
        },
        exportLot() {
            this.$store.commit('changeLoading', true);
            Lots.export(this.allotment_id).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'lotes.xlsx');
                link.click();
                this.$store.commit('changeLoading', false);
            });
        },
        setModalReadjustment() {
            this.modalTitle = 'LOTS.VALUE_READJUSTMENT';
            this.whichModal = 5;
        },
        setModalBlockLiberty() {
            this.status_from = [];
            this.status_to = [];
            this.propertiesStatus.forEach(i => {
                if (i.can_select) {
                    this.status_to.push(i);
                }
                if (i.type === 4 || i.type === 0) {
                    this.status_from.push(i);
                }
            });
            this.modalTitle = 'LOTS.ALTER_STATUS_LOTS';
            this.whichModal = 6;
        },
        setModalAlterStep() {
            this.status_from = [];
            this.status_to = [];
            this.modalTitle = 'LOTS.ALTER_STEP_LOTS';
            this.whichModal = 7;
        },
        changeAllotment({id}, clearStep = false) {
            this.$store.commit('changeLoading', true);
            if (clearStep) {
                sessionStorage.removeItem('stepId');
                sessionStorage.removeItem('statusId');
            }
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.setItem('allotmentIdScope', id);
            this.allotmentSelect = this.allotments.find(item => item.id === id);
            this.$router.go();
        },
        startLot(allotment_id, updateBlock) {
            if (allotment_id) {
                this.indexBlocks(allotment_id, updateBlock);
                this.indexReserveTypeIndex(allotment_id);
            }
        },
        async allotmentSelected() {
            await UserCompanies.chanceCustomScope(sessionStorage.getItem('allotmentIdScope')).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
                this.allotment_id = sessionStorage.getItem('allotmentIdScope');
                this.settingsOwner.ajax.headers['allotment-id'] = this.allotment_id;
                this.allotmentSelect = this.allotments.find(item => item.id === this.allotment_id);
                this.startLot(this.allotment_id, true);
                if (sessionStorage.getItem('allotmentIdScope')) {
                    this.listSteps()
                }
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        async indexBlocks(allotment_id, updateBlock = false, stopLoopLots) {
            this.$store.commit('changeLoading', true);
            if (stopLoopLots) {
                this.$store.dispatch('ActionListLotModified', stopLoopLots);
            }
            this.blocks = null;
            this.hasBlocks = null;
            this.blockOpen = null;
            await Lots.blocksList(allotment_id, undefined, null, this.step_id, this.status_id, this.owner_id)
                    .then(resp => this.blocks = resp.data)
                    .catch(err => {
                        this.errorMsg(err);
                        this.$store.commit('changeLoading', false);
                    });
            if (!this.blocks.validations) {
                this.hasBlocks = true;
                this.listLotsModified();
                this.blocks.forEach(block => block.title = block.text.replaceAll(' ', ''));
                this.blockOpen = this.blocks[0].text;
                this.indexLotsByAllotment(allotment_id, this.blockOpen, updateBlock);
            }
            this.$store.commit('changeLoading', false);
        },
        indexLotsByAllotment(allotment_id, block_id, updateBlock = false) {
            if (!this.lots[block_id] || updateBlock) {
                this.isLoadingLots = {block: block_id, isLoading: true};
                Lots.lotsByAllotmentAndBlock(allotment_id, block_id, null, this.step_id, this.status_id, this.owner_id)
                        .then(resp => {
                            if (resp.data?.lots?.length) {
                                const lots = resp.data.lots;
                                lots.forEach(i => {
                                    i.status = this.getStatusById(i.properties_status_id);
                                    i.properties_type_name = this.propertiesType.find(t => t.id === i.properties_type_id)?.text;
                                });
                                this.lots[block_id] = lots;
                            } else {
                                this.lots[block_id] = [];
                            }
                        }).catch(error => this.errorMsg(error)).finally(() => this.isLoadingLots.isLoading = false);
            }
        },
        afterEdit() {
            this.$router.go();
        },
        afterCreate(properties) {
            const block_id = properties.properties.block;
            const allotment_id = properties.properties.allotment_id;
            this.updateLots(allotment_id, block_id, false);
        },
        async setShowModal(lots) {
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'LOTS.LOT_INFORMATION';
            lots.status = lots.status ?? this.getStatusById(lots.properties_status_id);
            await Allotments.showOnlyBd(lots.allotment_id).then(resp => lots.allotments = resp.data);
            this.$store.commit('changeLoading', false);
            this.lotsIndex = lots;
        },
        base64_encode(string) {
            if (string) {
                return btoa(unescape(encodeURIComponent(string)));
            }
            return string;
        },
        setSimulateModal(lot, type) {
            this.whichModal = 4;
            document.getElementById('closeModal').click();
            this.modalTitle = type === 'simulate' ? 'LOTS.MODAL_TITLE.SIMULATE' : 'LOTS.CREATE_PROPOSE';
            this.buildSimulatorUrl(lot.lot.property_id, localStorage.getItem('companyId'))
                .then(url => this.srcIframe = url)
                .catch(err => this.errorMsg(err));
        },
        setViewModal(lote_id) {
            this.whichModal = 3;
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'LOTS.MODAL_TITLE.VIEW';
            document.getElementById('closeModal').click();
            Lots.show(lote_id).then(resp => {
                const statusP = this.propertiesStatus.find(i => i.id === resp.data.properties.properties_status_id);
                resp.data.properties.properties_status = statusP.can_select ? this.propertiesStatus.filter(i => i.can_select) : [statusP];
                resp.data.properties.properties_types = this.propertiesType;
                this.properties = resp.data.properties;
                this.lotsIndex = resp.data;
            }).catch(error => this.errorMsg(error))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        async setEditModal(lote_id) {
            document.getElementById('closeModal').click();
            this.isEdit = true;
            this.whichModal = 1;
            this.$store.commit('changeLoading', true);
            await Lots.show(lote_id).then(resp => {
                const statusP = this.propertiesStatus.find(i => i.id === resp.data.properties.properties_status_id);
                resp.data.properties.properties_status = statusP.can_select ? this.propertiesStatus.filter(i => i.can_select) : [statusP];
                resp.data.properties.properties_types = this.propertiesType;
                this.properties = resp.data.properties;
                this.lotsIndex = resp.data;
                this.properties.allotments = null;
                this.modalTitle = 'LOTS.MODAL_TITLE.EDIT';
            }).catch(error => this.errorMsg(error))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        setRegisterModal() {
            this.whichModal = 1;
            if (!this.hastwoAllotments && !this.allotments) {
                this.$store.dispatch('ActionUpdateMenu', 'allotment', false);
                this.$store.commit('displayMenssageAllotmentRequired', true);
                this.$router.push({name: 'IndexAllotmant'});
            } else {
                this.isEdit = false;
                this.properties = {
                    name: null,
                    block: null,
                    price: null,
                    status: null,
                    latitude: null,
                    longitude: null,
                    cci: null,
                    total_area: null,
                    description: null,
                    properties_type_id: null,
                    allotment_id: this.allotment_id,
                };
                this.lotsIndex = {
                    left_size: null,
                    back_size: null,
                    front_size: null,
                    right_size: null,
                    chamfer_size: null,
                    front_confrontation: null,
                    background_confrontation: null,
                    right_confrontation: null,
                    left_confrontation: null,
                    chamfer_confrontation: null,
                };
                this.modalTitle = 'LOTS.MODAL_TITLE.ADD';
            }
        },
        async indexSituation() {
            await Properties.indexSituation().then(resp => this.subtitles = resp.data?.data?.map((i) => {
                i.text = i.name;
                return i;
            }));
        },
        setDelete(properties) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Lots.delete(properties.id).then(() => {
                        const block_id = properties.block;
                        this.updateLots(this.allotment_id, block_id, true);
                        this.toast.success(this.t('GENERAL.MSG.DELETED_SUCCESS'));
                        document.getElementById('closeModal').click();
                    }).catch(error => this.errorMsg(error))
                            .finally(() => this.$store.commit('changeLoading', false));
                }
            });
        },
        updateLots(allotment_id, block, isDelete) {
            let blocksLength = 0;
            let updateWholeBlock = true;
            if (this.blocks.validations) {
                this.indexAllotment(true);
            } else {
                if (this.blocks.find(b => b.text == block)) {
                    updateWholeBlock = false;
                }
                if (isDelete) {
                    for (let id in this.lots) {
                        if (block == id) {
                            blocksLength = this.lots[id].length;
                        }
                    }
                }
                if ((updateWholeBlock && !isDelete) ||
                        (blocksLength == 1 && isDelete)) {
                    this.indexBlocks(allotment_id, true);
                } else {
                    this.indexLotsByAllotment(allotment_id, block, true);
                }
            }
        },
        listLotsModified() {
            clearInterval(this.loopLots);
            this.$store.dispatch('ActionListLotModified');
        },
        toCurrency(value) {
            if (value === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
        },
        setRegisterModalReserve(lot) {
            this.allotment = [];
            this.whichModal = 2;
            document.getElementById('closeModal').click();
            this.allotment.push(this.allotments.find(al => al.id == this.allotment_id));
            this.reserve = {
                block: 1,
                clients: [],
                realtors: [],
                observation: '',
                blocks: lot.block,
                isLotOrigin: true,
                reserve_type_id: null,
                allotments: this.allotment,
                property_id: lot.lot.property_id,
                allotment_id: this.allotment_id,
                lots: [{id: lot.id, text: lot.name}],
            };
            if (!this.$hasPermission('Reserve_confirm', true) && !this.reserveTypesIndex[0]) {
                this.toast.error(this.t('GENERAL.MSG.DONT_HAVE_RESERVE_TYPE_REGISTER'), {timeout: false});
            }
            this.modalTitle = 'RESERVE.MODAL_TITLE.ADD';
        },
        updateAfterCreated(reserve) {
            const allotment_id = reserve.allotment_id;
            const block_id = reserve.block_id;
            this.indexLotsByAllotment(allotment_id, block_id, true);
            this.reserve = null;
        },
        indexReserveTypeIndex(allotment_id) {
            if (allotment_id) {
                ReserveTypes.list(allotment_id).then(resp => this.reserveTypesIndex = resp.data).catch(err => this.errorMsg(err));
            }
        },
        importFile(file) {
            this.$store.commit('changeLoading', true);
            Lots.import(file, this.allotment_id).then(resp => {
                this.updateLots(this.allotment_id, resp.data);
                this.toast.success(this.t('GENERAL.MSG.LOTS_IMPORT_WITH_SUCCESSS'));
            }).catch(error => this.errorMsg(error)).finally(() => {
                this.uploadFile = false;
                this.$store.commit('changeLoading', false);
            });
        },
    },
};
</script>

<style>
.paddin {
    padding-left: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.5rem;
}

.no-border {
    border: 0px solid #0e5e4e;
}

.dropdown-black {
    background: #333333;
}

.text-white {
    color: white;
}

.font-15 {
    font-size: 15px;
}

.dropdown-lot {
    width: 245px;
    left: 4px !important;
}

.dropdown-lot::before {
    border-bottom: 9px solid #333333;
    opacity: 0.9;
}

.red {
    color: red;
}

.item-custom2 {
    padding-top: 6px;
    padding-bottom: 2px;
}

.lot-block-header-link {
    align-items: center;
    display: flex !important;
    justify-content: flex-start;
    padding-right: 1.75rem;
    text-decoration: none !important;
    width: 100%;
}

.lot-block-header-title {
    align-items: center;
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.lot-block-header-title i {
    align-items: center;
    background: #e7f4f0;
    border-radius: 8px;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 0.85rem;
    height: 26px;
    justify-content: center;
    width: 26px;
}

.lot-block-header-count {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0.25rem 0.55rem;
    white-space: nowrap;
}

html.dark-theme .lot-block-header-title i,
html.dark-theme .lot-block-header-count {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}
</style>
